import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ThemeProvider } from 'styled-components';
import siteTheme from '../../cms/site-theme.json';
import { applySiteTheme } from '../../utils/applySiteTheme';
import Header from './Header';
import Footer from './Footer';

// Styled components for layout
const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
  background-color: ${props => props.theme.colors.background};
`;

const Layout = ({ children }) => {
  const theme = useMemo(() => applySiteTheme(siteTheme), []);

  return (
    <ThemeProvider theme={theme}>
      <LayoutWrapper>
        <Header />
        <Main>
          {children}
        </Main>
        <Footer />
      </LayoutWrapper>
    </ThemeProvider>
  );
};

export default Layout; 